<div class="card card-custom gutter-b">
    <div class="card-header">
        <div class="card-title">
            <h2 class="card-label">Converteste fisier</h2>
        </div>
    </div>
    <div class="card-body pb-10">
        <div class="pb-5">
            <h5>Incarca fisierul pe care vrei sa il convertesti:</h5>
            <div class="input-group mb-3">
                <input type="file" class="form-control"  (change)="selectFile($event)" />
                <div class="input-group-append">
                    <a class="btn btn-primary font-weight-bold text-uppercase" (click)="uploadFile()">
                        Incarca fisier <i class="icofont-upload-alt"></i>
                    </a>
                </div>
            </div>
            <div class="spinner-container" *ngIf="showLoader">
                <mat-spinner></mat-spinner>
            </div>
        </div>
        <hr>
        <div class="pt-5">
            <h5>Continutul fisierului va aparea mai jos:</h5>
            <div [innerHTML]="fileContent"></div>
        </div>
    </div>
</div>
